// Derives the agent page_context (route + query filters + selected ids) from
// the current router location. Selected ids are passed in by the caller (the
// panel reads them from page-level selection state when available).

import { useLocation } from 'react-router-dom';
import type { PageContext } from '../types/agent';

export function usePageContext(
  selectedIds?: Array<string | number>
): PageContext {
  const location = useLocation();

  const filters: Record<string, string> = {};
  const params = new URLSearchParams(location.search);
  params.forEach((value, key) => {
    filters[key] = value;
  });

  const ctx: PageContext = { route: location.pathname };
  if (Object.keys(filters).length > 0) {
    ctx.filters = filters;
  }
  if (selectedIds && selectedIds.length > 0) {
    ctx.selected_ids = selectedIds;
  }
  return ctx;
}
